// @core/api/endpoints/authn/handle_oauth2_callback.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  HandleOAuth2CallbackRequest,
  HandleOAuth2CallbackResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Handle OAuth2 callback from external provider
 * Processes the callback from an external OAuth2 provider after user authentication. Exchanges the authorization code for tokens and creates or links the user account.
 */
export async function HandleOAuth2Callback(
  data: HandleOAuth2CallbackRequest,
  options?: RequestOptions
): Promise<HandleOAuth2CallbackResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/external/callback`;
  const requestOptions = options;
  return client.post<HandleOAuth2CallbackResponse>(requestPath, data, requestOptions);
}
